import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { getTimeStamp } from '../webcommon/common/helpers';

export const INITIAL_STATE = {
    columnsForReportGrid: constants.columnsGrid3,
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    runDate: '',
    initialisedMonthlyUpload: false,
    initialisedExport: false,
    initialisedDailyFiles: false,
    fileLoading: false,
    loadingMonthlyUpload: false,
    loadingExport: false,
    loadingDailyFiles: false,
    loadError:false,
    loadSuccess:false,
    currentServerFilters: [],
    fileName: null,
    fileUploadedAt: null,
    fileUploadRows: [],
    commodityReportRows:[],
    rowsPreview: [],
    isValidated: false,
    validationError: '',
    isUploaded: false,
    waitingForNotification: false,
    rowsDailyFiles: [],
    lastUpdatedDailyFiles: getTimeStamp(),
    lastUpdatedMonthly: getTimeStamp(),
    lastUpdatedExport: getTimeStamp(),
    gridSorting: [{ gridId: 'timestampSort', gridSort: [{ id: 'createdAt', desc: true }] }]
};
const setRunDate = fp.set('runDate');
const setExportInitialised = fp.set('initialisedExport');
const setDailyFilesInitialised = fp.set('initialisedDailyFiles');
const setMonthlyUploadLoading = fp.set('loadingMonthlyUpload');
const setExportLoading = fp.set('loadingExport');
const setDailyFilesLoading = fp.set('loadingDailyFiles');


export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        // monthly upload
        case actions.GET_MONTHLY_FILE_UPLOADS_SUCCESS:{
            return {
                ...state,
                fileUploadRows: action.rows,
                lastUpdatedMonthly: getTimeStamp()
            };}
        case actions.SET_MONTHLY_UPLOAD_INITIALISED:{
            return {
                ...state,
                initialisedMonthlyUpload: action.initialised
            };}
        case actions.SET_MONTHLY_UPLOAD_LOADING:
            return setMonthlyUploadLoading(action.loading, state); 
        case actions.UPLOAD_MONTHLY_FILE: {
            return {...state,fileLoading: true};}  
        case actions.UPLOAD_MONTHLY_FILE_SUCCESS: {
            return {
                ...state,
                fileName : action.result.data.fileName,
                fileUploadedAt : action.result.data.createdAt,
                isUploaded: true,
                isValidated: false,
                rowsPreview: [],
                waitingForNotification: true
            };
        }
        case actions.UPLOAD_MONTHLY_FILE_SUCCESS_CONFIRM: {                  

            return {
                ...state,
                isUploaded: false,
                waitingForNotification: false
            };
        }
        case actions.UPLOAD_MONTHLY_FILE_FAILED: {
            return {
                ...state,
                fileLoading: false,
                loadError: true
            };
        }  
        case actions.VALIDATE_MONTHLY_FILE_SUCCESS: {
            return {
                ...state,
                rowsPreview: action.result,
                isValidated: true
            };
        }       
        case actions.VALIDATE_MONTHLY_FILE_FAILED: {
            return {
                ...state,
                isValidated: false,
                validationError: action.error
            };
        }
        // export            
        case actions.GET_COMMODITY_REPORTS_SUCCESS:{
            return {
                ...state,
                commodityReportRows: action.rows,
                lastUpdatedExport: getTimeStamp()
            };    
        }
        case actions.SET_EXPORT_INITIALISED:
            return setExportInitialised(action.initialised, state);       
        case actions.SET_EXPORT_LOADING:
            return setExportLoading(action.loading, state); 
        case actions.SET_RUNDATE:
            return setRunDate(action.date, state);        
        case actions.SET_ROW_CHECKED: {
            return {
                ...state,
                commodityReportRows: state.commodityReportRows
                    .map(row => (row.id !== action.id ? row
                        : fp.set('selected', action.checked, row)))
            };
        }
        case actions.SET_ALL_ROWS_CHECKED: {
            return {
                ...state,
                commodityReportRows: state.commodityReportRows
                    .map(row => fp.set('selected', action.checked, row))
            };
        }  
        // daily files  
        case actions.SET_DAILY_FILES_INITIALISED:
            return setDailyFilesInitialised(action.initialised, state);
        case actions.SET_DAILY_FILES_LOADING:
            return setDailyFilesLoading(action.loading, state);     
        case actions.GET_DAILY_FILES_SUCCESS:{
            return {
                ...state,
                rowsDailyFiles: action.result,
                lastUpdatedDailyFiles: getTimeStamp()
            };
        }
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({
                        gridId: action.gridId,
                        gridSort: action.sorting
                    })
                };
            }

            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? fp.set('gridSort', action.sorting, sort) : sort)
                )
            };
        }
        default:
            return state;
    }
}
